var installedModules = {};
var moduleToHandlerMapping = {
	35098: {
		getter: () => (__webpack_require__.e(7270).then(() => (() => (__webpack_require__(21914))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	83110: {
		getter: () => (Promise.all([__webpack_require__.e(7270), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922)]).then(() => (() => (__webpack_require__(76071))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.3.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	93019: {
		getter: () => (Promise.all([__webpack_require__.e(7270), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922)]).then(() => (() => (__webpack_require__(10579))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	42820: {
		getter: () => (Promise.all([__webpack_require__.e(7270), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(5098), __webpack_require__.e(3019)]).then(() => (() => (__webpack_require__(15643))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.0.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"2820": [
		42820
	],
	"3019": [
		93019
	],
	"3110": [
		83110
	],
	"5098": [
		35098
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}